/**
 * Created by Victor Rojo on 18/2/19.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {logger} from "codelyzer/util/logger";

@Injectable()
export class ClearViewService{

  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  logout(): Promise<any>{
    let url = "https://clearview.wayne.com/wetstock/login.aspx?logout=true";
    return this.http.get(url, { responseType: 'text' })
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }

  getLoginParams(): Promise<any> {
    let promise = Promise.all([
      this.getHiddenInputs(),
      this.getCredentials()
    ]).then(values => {
      let params = {};
      let fields = ["__VIEWSTATEGENERATOR", "__EVENTVALIDATION", "__VIEWSTATE", "Submit1"];
      let parser = new DOMParser();
      let parsedHtml = parser.parseFromString(values[0], 'text/html')
      fields.forEach( field => {
        params[field] = parsedHtml.getElementById(field) ? parsedHtml.getElementById(field)["value"] : "";
      });
      if ( values[1] ) {
        let token = JSON.parse(values[1].token);
        params["txtUsername"] = token.txtUsername;
        params["txtPassword"] = token.txtPassword;
      }
      return params;
    });
    return promise;
  }

  private getHiddenInputs(): Promise<any>{
    let url = "https://clearview.wayne.com/wetstock/login.aspx";
    return this.http.get(url, { responseType: 'text' })
      .toPromise()
  }

  private getCredentials(): Promise<any>{
    let url = "api/v1/3pi/clearview";
    return this.http.get(url)
      .toPromise()
  }
}
